import React from "react";
import text from "../../locales/ru/ru.json";
import "./style.scss";
import { useTranslation } from "react-i18next";

export default function TextHelpList() {
  const { t } = useTranslation();
  return (
    <div>
      <div className="compromise-description-modal__title">
        {t("modals.help_compromise.description")}
      </div>
      <ul className="help-list">
        {text.modals.help_compromise.description_list.map((item, i) => {
          return (
            <li key={i} className="help-list__item">
              <div className="help-list__item__dot" />
              <div className="help-list__item__name">
                {t(`modals.help_compromise.description_list.${i}.question`)}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
